module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-346e22f0.png";